@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <div class="w-100 flex-1">
    <div [innerHTML]="message"></div>
    <img [src] = "qrCodeSetupImageUrl" class="qrCode"/>
    <div class="manualKey"><b>Manual Key: </b>{{manualEntryKey}}</div>
    <form [formGroup]="dialogForm" class="mt-3">
      <mat-form-field  appearance="outline" class="w-100">
        <mat-label>Enter Code</mat-label>
        <input matInput formControlName="code" required>
        @if (dialogForm.controls.code.errors?.required) {
          <mat-error>Code is required</mat-error>
        }
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions >
  <div class="w-100 flex-row justify-end items-center mt-3 mr-3">
    <a mat-button class="mr-5" color="primary" (click)="onCancelClick()" ><span class="text-bold">{{cancelButtonText}}</span></a>
    <a mat-button color="primary" (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>
